var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var History_1 = require("../History");
function getPreservedParams(nextURL, params) {
    var urlParams = params ? getQueryValuesFromURL() : {};
    if (params instanceof Array) {
        for (var key in urlParams) {
            params.indexOf(key) < 0 && (delete urlParams[key]);
        }
    }
    return objectToQueryString(__assign({}, urlParams, getQueryValuesFromURL(nextURL)));
}
function trimHashAndSearch(url) {
    var MAX_LEN = 99999;
    var searchIndex = url.indexOf('?'), hashIndex = url.indexOf('#');
    searchIndex = searchIndex > 0 ? searchIndex : MAX_LEN;
    hashIndex = hashIndex > 0 ? hashIndex : MAX_LEN;
    var index = searchIndex < hashIndex ? searchIndex : hashIndex;
    return index !== MAX_LEN ? url.substring(0, index) : url;
}
function getQueryValuesFromURL(url) {
    if (url && url.indexOf('?') > 0) {
        url = url.substring(url.indexOf('?'));
        var hashIndex = url.indexOf('#');
        url = hashIndex > 0 ? url.substring(0, hashIndex) : url;
    }
    else if (url) {
        url = '?';
    }
    var search = (url || window.location.search).substr(1);
    return search ? JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}', function (key, value) { return key === "" ? value : decodeURIComponent(value); }) : {};
}
function objectToQueryString(obj) {
    if (typeof obj !== 'object')
        return;
    var query = '';
    for (var key in obj) {
        query += '&' + key + '=' + obj[key];
    }
    return query ? '?' + query.substr(1) : '';
}
function jumpTo(url, hash, searchObj, isOpenInNewTab) {
    var search = '';
    searchObj && Object.getOwnPropertyNames(searchObj).forEach(function (key) {
        search += "&" + key + "=" + searchObj[key];
    });
    if (hash)
        url += '#' + hash;
    if (!!search)
        url += '?' + search.substr(1);
    if (isOpenInNewTab) {
        var win = window.open(url, '_blank');
        if (win) {
            win.focus();
        }
        else {
            window.location.href = url;
        }
    }
    else {
        window.location.href = url;
    }
}
function goBack() {
    window.history.back();
}
function transitTo(url, preserveQueryParams, preventReferenceUpdate) {
    !preventReferenceUpdate && (window['__widgetReferrer'] = window.location.href);
    History_1.default.push && History_1.default.push(trimHashAndSearch(url) + getPreservedParams(url, preserveQueryParams));
}
function redirectTo(url, preserveQueryParams) {
    History_1.default.replace && History_1.default.replace(trimHashAndSearch(url) + getPreservedParams(url, preserveQueryParams));
}
function updateQuery(url, queryParams) {
    if (History_1.default.push && url && queryParams) {
        History_1.default.push(url + objectToQueryString(__assign({}, getQueryValuesFromURL(), queryParams)));
    }
}
exports.default = {
    getQueryValuesFromURL: getQueryValuesFromURL,
    objectToQueryString: objectToQueryString,
    jumpTo: jumpTo,
    goBack: goBack,
    transitTo: transitTo,
    redirectTo: redirectTo,
    updateQuery: updateQuery,
};
